import { cn } from "@/lib/utils";

const CH = {
  Shopee: "bg-orange-50 text-orange-800 border-orange-200",
  "Tokopedia/TikTok": "bg-emerald-50 text-emerald-800 border-emerald-200",
  WhatsApp: "bg-green-50 text-green-800 border-green-300",
  Offline: "bg-zinc-100 text-zinc-900 border-zinc-300",
};

export const ChannelChip = ({ channel, className }) => (
  <span data-testid="channel-chip" className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold", CH[channel] || CH.Offline, className)}>
    {channel}
  </span>
);

export const SalesTypeBadge = ({ type }) => (
  <span className={cn("inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold",
    type === "Sales" ? "border-ink text-ink" : "border-brand bg-brand-soft text-brand")}>
    {type}
  </span>
);

export const VoidBadge = ({ txn }) =>
  txn?.status === "void" ? (
    <span data-testid="void-badge" className="rounded bg-brand px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">Void</span>
  ) : null;

export const Tag = ({ children, tone = "ink", className }) => (
  <span className={cn("inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold",
    tone === "red" ? "bg-brand text-white" : tone === "soft" ? "bg-zinc-100 text-zinc-700" : "bg-ink text-white", className)}>
    {children}
  </span>
);
